/**
 * @voltxampere/ui — PanTool (Sprint 12)
 *
 * Drag-to-pan tool. Engaged by Space-hold (the host element
 * pushes/pops `SelectTool` ↔ `PanTool` on the keyboard tool
 * stack); on `pointerdown` it captures the pointer so the drag
 * keeps tracking even when the cursor leaves the canvas.
 *
 * `Viewport.pan(dxScreen, dyScreen)` already divides by the
 * current zoom — the pan delta arrives at the viewport in screen
 * pixels.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export class PanTool {
    id = "pan";
    cursor = "grab";
    dragging = false;
    lastClientX = 0;
    lastClientY = 0;
    onPointerDown(e, ctx) {
        if (e.button !== 0)
            return;
        this.dragging = true;
        this.lastClientX = e.clientX;
        this.lastClientY = e.clientY;
        try {
            ctx.canvas.setPointerCapture(e.pointerId);
        }
        catch {
            // happy-dom may throw when pointer capture is unsupported.
        }
    }
    onPointerMove(e, ctx) {
        if (!this.dragging)
            return;
        const dx = e.clientX - this.lastClientX;
        const dy = e.clientY - this.lastClientY;
        this.lastClientX = e.clientX;
        this.lastClientY = e.clientY;
        ctx.viewport.pan(dx, dy);
        ctx.invalidate();
    }
    onPointerUp(e, ctx) {
        if (!this.dragging)
            return;
        this.dragging = false;
        try {
            if (ctx.canvas.hasPointerCapture(e.pointerId)) {
                ctx.canvas.releasePointerCapture(e.pointerId);
            }
        }
        catch {
            // ignore
        }
    }
    onLeave() {
        this.dragging = false;
    }
}
//# sourceMappingURL=pan.js.map